module.exports = __webpack_public_path__ + "media/images/icons/edit_admin-d7ac517ce8433d42db2fa47e8619ed1e.svg";